import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Page404 } from './index';

const BASE_URL = 'https://youngstartup.com';
const EVENTS_BASE_URL = `${BASE_URL}/events/vsw26`;
const API_BASE_URL = 'https://youngstartup.io/api/red/gen?ysv_id=1';

const redirects = {
   'vc-dashboard': `${BASE_URL}/vc-accounts`,

   'featured-sponsor-submission': `${EVENTS_BASE_URL}/forms/c5c8d38e-4f35-4a76-84f0-ef4791b5d033`,
   'form-success': `${EVENTS_BASE_URL}/form-success`,
   'invited-judge-submission': `${EVENTS_BASE_URL}/forms/c1f17572-8594-4a15-b7ba-9b0ea03a0642`,
   'invited-partner-submission': `${EVENTS_BASE_URL}/forms/c95a0e48-0d72-4a4e-9052-64326db9d0b7`,
   'invited-speaker-submission': `${EVENTS_BASE_URL}/forms/08f272f8-3a4d-489a-b3e8-568a253d9995`,
   'nominations': `${EVENTS_BASE_URL}/forms/d454d0a1-4638-4313-85ee-7988c7706ab4`,
   'sponsor-submission': `${EVENTS_BASE_URL}/forms/c5c8d38e-4f35-4a76-84f0-ef4791b5d033`,
   'thank-you-for-your-submission': `${EVENTS_BASE_URL}/forms/thank-you`,

   'upcoming': EVENTS_BASE_URL,
   'upcoming/agenda': `${EVENTS_BASE_URL}/agenda`,
   'upcoming/form-success': `${EVENTS_BASE_URL}/form-success`,
   'upcoming/partners': `${EVENTS_BASE_URL}/partners`,
   'upcoming/press': `${EVENTS_BASE_URL}/press`,
   'upcoming/registration': `${EVENTS_BASE_URL}/registration`,
   'upcoming/speakers': `${EVENTS_BASE_URL}/speakers`,
   'upcoming/sponsors': `${EVENTS_BASE_URL}/partners`,
   'upcoming/startups': `${EVENTS_BASE_URL}/startups`,
   'upcoming/tickets': `${EVENTS_BASE_URL}/tforms/d338092b-fec3-4e14-b2f4-97e27b00e8a4`,
   'upcoming/top-innovators': `${EVENTS_BASE_URL}/startups`,
   'upcoming/upgrade-to-gold': `${EVENTS_BASE_URL}/tforms/689b44b331e68`,
   'upcoming/venue': `${EVENTS_BASE_URL}/venue`,
   'upcoming/venture-nurturing': `${EVENTS_BASE_URL}/venture-nurturing`,
   'upcoming/volunteer': `${EVENTS_BASE_URL}/volunteer`,
   'upcoming/volunteers': `${EVENTS_BASE_URL}/volunteer`,

   'AWIS': `${API_BASE_URL}&src_table=AWIS&link_id=108`,
   'BlueStartups': `${API_BASE_URL}&src_table=BlueStartups&link_id=107`,
   'CGHI': `${API_BASE_URL}&src_table=CGHI&link_id=106`,
   'ConsumerVC': `${API_BASE_URL}&src_table=ConsumerVC&link_id=105`,
   'DevIT_Jobs': `${API_BASE_URL}&src_table=DevIT_Jobs&link_id=104`,
   'Disruptionbanking': `${API_BASE_URL}&src_table=Disruptionbanking&link_id=102`,
   'EFFlinkedin': `${API_BASE_URL}&src_table=EFFlinkedin&link_id=111`,
   'israelstartupnetwork': `${API_BASE_URL}&src_table=israelstartupnetwork&link_id=110`,
   'li1-vsw24': `${API_BASE_URL}&src_table=LinkedIn&link_id=112`,
   'mhin': `${API_BASE_URL}&src_table=mhin&link_id=114`,
   'Startup-Victoria': `${API_BASE_URL}&src_table=Startup-Victoria&link_id=100`,
   'the-CLUB': `${API_BASE_URL}&src_table=the-CLUB&link_id=101`,
   'women-in-tech': `${API_BASE_URL}&src_table=women-in-tech&link_id=113`,
   'co-founders-lab': `${API_BASE_URL}&src_table=co-founders-lab&link_id=103`,
   'draperuniversity': `${API_BASE_URL}&src_table=draperuniversity&link_id=109`,
   'isnvip': `${API_BASE_URL}&src_table=ISNVIP&link_id=103`,

   'ANVVIP': `${API_BASE_URL}&src_table=ANVVIP&link_id=52&red_to=https`,
   'cbcvip': `${API_BASE_URL}&src_table=cbcvip&link_id=52&red_to=https`,
   'cghivip': `${API_BASE_URL}&src_table=cghivip&link_id=52&red_to=https`,
   'fnavip': `${API_BASE_URL}&src_table=fnavip&link_id=52&red_to=https`,
   'fnmx': `${API_BASE_URL}&src_table=fnmx&link_id=52&red_to=https`,
   'itavip': `${API_BASE_URL}&src_table=itavip&link_id=52&red_to=https`,
   'medstartr': `${API_BASE_URL}&src_table=medstartr&link_id=52&red_to=https`,
   'NAVOBA': `${API_BASE_URL}&src_table=navoba&link_id=53&red_to=https`,
   'svvip': `${API_BASE_URL}&src_table=svvip&link_id=52&red_to=https`,

   'vs-virtual-connect': 'https://events.bizzabo.com/346074/agenda',
};

export const Redirects = () => {
    const location = useLocation();
    const [isFound, setIsFound] = useState(true);

    useEffect(() => {
        const path = location.pathname
              .replace(/^\//, '')
              .replace(/\/$/, '');

        if (redirects[path] !== undefined) {
            window.location.href = redirects[path];
        } else {
            setTimeout(() => setIsFound(false), 1000);
        };

    }, [location]);

    return isFound
        ? <div style={{
            marginTop: '100px',
            position:'relative',
            backgroundColor: 'var(--theme-color)',
            minHeight: '50vh'
        }}> <div id="loader" /></div>
    : <Page404 />;
};
